<template>
  <div class="team wh100">
    <el-card
      class="left-box wh100"
      body-style="height:calc(100% - 49px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px;"
      v-loading="dataLoading"
    >
      <div slot="header" class="clearfix" style="height: 29px">
        <!-- <span style="font-size: 18px; font-weight: bold">项目供应商</span> -->
        <!-- <el-button
          type="primary"
          size="mini"
          icon="el-icon-plus"
          style="float: right; margin-right: 10px"
          @click="openDialog"
          >增加供应商</el-button
        >
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-download"
          style="float: right; margin-right: 10px"
          @click="getExcel"
          >导出</el-button
        > -->
      </div>
      <div style="height: calc(100% - 10px)">
        <el-table
          :data="data"
          style="width: 100%"
          row-key="Id"
          height="calc(100%)"
          v-loading="dataLoading"
          :tree-props="{ children: 'children' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="55"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="ParentSupplierName"
            label="供应商名称"
            width="360"
            sortable
          />
          <el-table-column
            prop="cVenName"
            label="分包商名称"
            width="360"
            sortable
          />
          <el-table-column
            prop="cVenPerson"
            label="联系人"
            width="150"
            sortable
          />
          <el-table-column
            prop="cVenPhone"
            label="联系电话"
            width="150"
            sortable
          />
          <el-table-column
            prop="EquipmentClassificationName"
            label="设备分类"
            sortable
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                placement="top"
                :disabled="!scope.row.EquipmentClassificationName || scope.row.EquipmentClassificationName.length <= 30"
              >
                <div slot="content" class="custom-tooltip-content">
                  <div
                    v-for="(item, index) in formatTooltipContent(scope.row.EquipmentClassificationName)"
                    :key="index"
                    class="tooltip-item"
                  >
                    <span class="tooltip-icon-square"></span>
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="ellipsis-cell">
                  {{ scope.row.EquipmentClassificationName || '-' }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="SupplierQualificationName"
            label="项目资料类型"
            width="350"
          />
          <el-table-column
            prop="SupplierTypeName"
            label="资质资料类型"
            width="200"
          />
          <el-table-column
            prop="UserName"
            label="创建人"
            width="100"
            fixed="right"
          /> -->
          <el-table-column
            prop="CreateTime"
            label="创建时间"
            width="150"
            sortable
          >
            <template slot-scope="scope">
              {{
                scope.row.CreateTime
                  ? moment(scope.row.CreateTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import tools from '@/utils/tools'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  props: {
    pId: { type: String, require: true },
    parentOBJ: { type: Object },
  },
  components: {},
  data() {
    return {
      moment,
      shareTokenLoading: false,

      shareToken: '',
      downloadUrl: '',
      data: [],
      OutSourceDataList: [],
      localdata: [],
      imageUrl: '', // 新建团队图像
      userName: '', // 名称
      newCreateUser: '',
      dialogVisible: false,
      IsManage: true,
      OutSourceLoading: false,
      loading: false,
      dataLoading: false,
      editVisible: false,
      item: {},
      TreeData: [],
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      EquipmentClassificationIds: [],
      InfoVisible: false,
      DocumentList: [],
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    pId: {
      handler(n) {
        if (n) {
          this.getDataList()
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 格式化 tooltip 内容，将逗号分隔的字符串转换为数组
    formatTooltipContent(text) {
      if (!text) return []
      return text.split(',').map(item => item.trim()).filter(item => item)
    },
    async getExcel() {
      await tools.download(
        this.$rootUrl +
          `/Base_ProjectWork/Base_ProjectSupplier/ExportInputOutToExcel?ProjectId=${this.pId}`,
        '供应商信息',
        '.xlsx'
      )
    },

    getDataList() {
      this.dataLoading = true
      this.$http
        .post(
          `/Base_ProjectWork/Base_ProjectSupplier/GetProjectSupplierTree?ProjectId=${this.pId}&Type=2`
        )
        .then((res) => {
          this.dataLoading = false
          if (res.Success) {
            this.data = res.Data
            this.IsManage = this.data.some(
              (item) => item.UserId == this.userInfo.Id && item.IsManage
            )
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.avatar-uploader-icon {
  font-size: 34px;
  color: #8c939d;
  width: 100%;
  height: 90px;
  line-height: 90px;
  text-align: center;
  cursor: pointer;
}

.avatar {
  width: 100%;
  height: 120px;
  display: block;
}

.paddingBox {
  padding: 16px;
  box-sizing: border-box;
}

.team {
  // padding-top: 10px;

  .teamBox {
    margin-right: 10px;
    margin-bottom: 10px;
    // width: 150px;
    // display: flex;

    .badge {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #409eff;
      color: #fff;
      border-bottom-right-radius: 13px;
      font-size: 12px;
      padding: 3px;
      padding-right: 5px;
    }

    .badgeRight {
      position: absolute;
      cursor: pointer;
      bottom: 0;
      right: 0;
      background-color: #aba1a1;
      color: #fff;
      width: 40px;
      text-align: center;
      font-size: 12px;
      padding: 3px;
      padding-right: 5px;
    }
    .share {
      position: absolute;
      cursor: pointer;
      top: 0;
      right: 0;
      background-color: #aba1a1;
      color: #fff;
      text-align: center;
      font-size: 12px;
      padding: 5px;
      padding-right: 5px;
    }

    .badgeRight:hover {
      background: #ec0f31;
    }
    .share:hover {
      background: #409eff;
    }

    .del {
      position: absolute;
      top: 5px;
      right: 5px;
      color: #409eff;
      cursor: pointer;
    }
  }

  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    height: 50px;
    width: 50px;
    // margin: 0 auto;
    display: block;
    border-radius: 50%;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }

  .clearfix:after {
    clear: both;
  }
}

::v-deep .left-box {
  .el-card__header {
    padding: 10px;
    border: none;
  }
}

.ellipsis1 {
  overflow: hidden; //超出隐藏
  word-wrap: break-word;
  word-break: normal;
  text-overflow: ellipsis; //文本超出时显示省略号

  display: -webkit-box;

  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）

  -webkit-line-clamp: 1; //内容限制的行数
}
// ::v-deep .editTree .el-tree-node__children .el-tree-node {
//   float: left;
// }
::v-deep .el-descriptions-item__label {
  font-size: 16px;
  font-weight: bold;
  width: 20%;
}
::v-deep .el-descriptions-item__content {
  font-size: 14px;
}
::v-deep.el-table__cell {
  background: #ffffff;
}

/* 自定义 tooltip 内容样式 - 三列布局 */
.custom-tooltip-content {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  gap: 8px 16px;
  max-width: 600px;
  max-height: 300px;
  overflow-y: auto;
  padding: 8px 4px;
  line-height: 1.8;
}

.tooltip-item {
  display: flex;
  align-items: flex-start;
  font-size: 13px;
  line-height: 1.8;
  word-break: break-word;
  padding: 2px 4px;
  color: #fff;
}

.tooltip-icon-square {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #67c23a;
  margin-right: 8px;
  margin-top: 6px;
  flex-shrink: 0;
}

.ellipsis-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  cursor: default;
}
</style>
